import { Route } from 'kts-platform-frame/routes';
import Qualification from './Qualification';
import AgentAgree from './AgentAgree';
import DefaultUI from './UI.Components';
import DidManager from '../DiDManager';
const parentName: string = '/workbench/platform/companyInfo';
Route.addNode(
    parentName,
    { nodeName: 'companyInfo', exact: true, path: '*/platform/companyInfo', component: DefaultUI },
    { nodeName: 'qualification', path: '*/qualification', component: Qualification },
    { nodeName: 'agentAgree', path: '*/agentAgree', component: AgentAgree },
    { nodeName: 'did', path: '*/did', component: DidManager },
);

export default {
    getChildReact: (index?: string) => {
        return Route.getChildReact(parentName, index);
    },
};

export {
    Switch
} from 'react-router-dom';



// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/Modules.Route.tsx